import Swiper, { Navigation } from 'swiper';
import { getNearbyDay } from '../get-schedule.js';

export function initWidgetsSlider() {
  document.querySelectorAll('.dke_widget-slider').forEach(el => {
    const swiperEl = el.querySelector('.swiper');
    const prev = el.querySelector('.dke_widget-button-prev');
    const next = el.querySelector('.dke_widget-button-next');
    new Swiper(swiperEl, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
    });
  });
}

export function insertDefaultLogoWidget() {
  const widgetLogoElements = document.querySelectorAll(
    '.dke_meteor .dke_widget__logo img'
  );
  widgetLogoElements.forEach(item => {
    item.insertAdjacentHTML(
      'afterend',
      '<span class="dke_widget-meteor-logo"></span>'
    );
  });
}

export function nextTripWidget() {
  const widgetNextTrip = document.querySelectorAll('.dke_widget__next');
  widgetNextTrip.forEach(item => {
    const tripId = item.dataset.tripId;
    if (tripId) {
      fetch('/ajax/next_trip?trip_id=' + tripId)
        .then(response => {
          return response.json();
        })
        .then(function (res) {
          if (res.status) {
            const nextDay = getNearbyDay(res.next_trip);
            if (nextDay) {
              item.querySelector('a').textContent = nextDay;
              item.classList.remove('dke_widget__next-hide');
            }
          }
        });
    }
  });
}

export function getLink(url) {
  if (url.length === 0) return '';

  if (!url.startsWith('http') && !url.startsWith('/')) {
    return '/' + url;
  }

  return url;
}

export function getWidgetData(form) {
  const formData = new FormData(form);
  const widgetData = {};
  for (let data of formData.entries()) {
    if (data[0] === 'link-id' && data[1].length === 0) {
      alert('Необходимо заполнить поле с ссылкой или id');
      return;
    }

    switch (data[0]) {
      case 'link-id':
        if (Number.isInteger(+data[1])) {
          widgetData.id = data[1];
        } else {
          widgetData.button_link = getLink(data[1]);
        }
        break;
      case 'logo_url':
      case 'img_url':
      case 'footer_button_link':
        widgetData[data[0]] = getLink(data[1]);
        break;
      default:
        widgetData[data[0]] = data[1];
    }
  }

  return widgetData;
}